import { render, staticRenderFns } from "./AppliedMeasureList.vue?vue&type=template&id=2874a064&scoped=true&"
import script from "./AppliedMeasureList.vue?vue&type=script&lang=js&"
export * from "./AppliedMeasureList.vue?vue&type=script&lang=js&"
import style0 from "./AppliedMeasureList.vue?vue&type=style&index=0&id=2874a064&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874a064",
  null
  
)

export default component.exports